<template>
  <div class="dossier-agence">
    <HeaderHome :user="this.$store.state.user.prenom" />
    <div class="dossier-content" v-if="eleveSelected === null">
      <div class="greeting">
        <p><span @click="goToHome" style="cursor:pointer">Accueil</span> > Dossier</p>
        <h1>Gestion Dossier</h1>
        <p>Choisissez un élève et construisez son dossier</p>
      </div>

      <div class="header-dossier">
        <div class="search-student">
          <SimpleTypeahead
            id="typeahead_id"
            :key="typeaheadKey"
            placeholder="Rechercher un élève..."
            :items="elevesName"
            :minInputLength="1"
            :itemProjection="
              (item) => {
                return item.fullname;
              }
            "
            @selectItem="selectItem"
            @onInput="searchEleve"
          >
          </SimpleTypeahead>
          <button class="cancel-select" v-if="cancelSearch" @click="cancelChoice">X</button>
        </div>
        <select
          class="selectTab"
          name="modes"
          id="modes"
          v-model="doss"
          @change="changeMode()"
        >
          <option value="">Tous</option>
          <option value="incomplet">Incomplet</option>
          <option value="validées">Validées</option>
          <option value="a traiter">À traiter</option>
          <option value="saisi">Saisi</option>
          <option value="enregistrer">Enregistrer</option>
        </select>
      </div>

      <div class="tableau">
        <DataTable
          :value="elevesDossier"
          :rows="10"
          v-model:filters="filters"
          v-model:selection="eleveSelected"
          selectionMode="single"
          filterDisplay="menu"
          :globalFilterFields="[
            'datep',
            'nom',
            'prenom',
            'dossier.dateNaissance',
            'dossier.statutDossier',
          ]"
          responsiveLayout="scroll"
          dataKey="id"
          @click="selectEleve"
        >
          <Column field="datep" header="Date"></Column>

          <Column field="nom" header="Nom"></Column>

          <Column field="prenom" header="Prenom"></Column>

          <Column field="dossier.dateNaissance" header="Age">
            <template #body="{ data }">
              <template v-if="data.dossier.dateNaissance.date">
                {{ calculateAge(data.dossier.dateNaissance.date) }}
              </template>
              <template v-else>
                {{ calculateAge(data.dossier.dateNaissance) }}
              </template>
            </template>
          </Column>

          <Column
            field="dossier.statutDossier"
            header="Statut"
            :sortable="true"
          >
            <template #body="{ data }">
              {{ data.dossier.statutDossier }}
            </template>
          </Column>
        </DataTable>
        <Paginator
          :rows="10"
          :totalRecords="countEleves"
          v-model:first="currentPage"
          @page="onPaginate"
        ></Paginator>
      </div>
    </div>
    <DossierSelected v-if="eleveSelected !== null" :student="eleveSelected" @cancelSelect="cancelSelect"/>
  </div>
</template>
<script>
import HeaderHome from "../../../components/home/HeaderHome.vue";
import SimpleTypeahead from "vue3-simple-typeahead";
import { FilterMatchMode } from "primevue/api";
import DossierSelected from "../../../components/agence/dossier/DossierSelected.vue";


export default {
  components: {
    HeaderHome,
    SimpleTypeahead,
    DossierSelected
  },

  data() {
    return {
        countEleves: 0,
        agenceSelected: "all",
        filters: {
            global: { value: null, matchMode: FilterMatchMode.CONTAINS },
        },
        eleveSelected: null,
        elevesName: [],
        cancelSearch: false,
        typeaheadKey: 0,
        doss: "a traiter",
        currentPage: 0
    }
  },

  mounted() {
    this.getElevesDossier(0, "dossier", this.doss);
    this.getCountEleves(this.doss);
    if (this.$store.state.eleveSelectAgence !== null) {
      const id = this.$store.state.eleveSelectAgence;
      this.$store.commit("setEleveSelectAgence", null);
      this.selectItem({ id });
    }
  },

  methods: {

    calculateAge(dateNaissance) {
      const birth = new Date(dateNaissance);
      const today = new Date();
      let age = today.getFullYear() - birth.getFullYear();
      const m = today.getMonth() - birth.getMonth();
      if (m < 0 || (m === 0 && today.getDate() < birth.getDate())) {
        age--;
      }
      return age;
    },

    goToHome() {
      this.$router.push({ name: "Home" });
    },

    cancelSelect(){
        this.eleveSelected = null;
        this.currentPage = 0;
        this.cancelSearch = false;
        if(this.doss != ""){
          this.getElevesDossier(0, "dossier", this.doss);
          this.getCountEleves(this.doss);
        }else{
          this.getElevesDossier(0, "null", "null");
          this.getCountEleves("null");
        }
    },

    onPaginate(e){
      let offset = e.first;
      this.offsetTable = offset;
      if(this.doss == ""){
        this.getElevesDossier(offset, "null", "null");
        this.getCountEleves("null");
      }else{
        this.getElevesDossier(offset, "dossier", this.doss);
        this.getCountEleves(this.doss);
      }
      
    },

    changeMode(){
      this.currentPage = 0;
      if(this.doss != ""){
        this.getElevesDossier(0, "dossier", this.doss);
        this.getCountEleves(this.doss);
      }else{
        this.getElevesDossier(0, "null", "null");
        this.getCountEleves("null");
      }
    },

    cancelChoice(){
      this.leleves = [];
      this.cancelSearch = false;
      this.typeaheadKey++;
      this.getElevesDossier(0, "null", "null");
    },

    selectItem(e){
      this.cancelSearch = true;
      this.itemS = e;
      window.api
        .get("/dossier/eleve/"+e.id, {
          headers: {
            Authorization: "Bearer " + this.$store.state.token,
          },
        })
        .then((response) => {

          this.$store.commit("setElevesDossier", response.data.utilisateur[0]);

          // Déséléctionne la pièce
          //this.unselectPiece();
          // Séléctionne l'élève
          this.eleveSelected = response.data.utilisateur[0];
          // Si l'élève est séléctionné
          if (this.eleveSelected !== null) {
            // Si la date de naissance doit être reformaté
            if (this.eleveSelected.dossier.dateNaissance.date != undefined) {
              // Reformatage de la date
              this.eleveSelected.dossier.dateNaissance =
                this.eleveSelected.dossier.dateNaissance.date;
            }
          }

        })
        .catch((error) => {
          console.log(error.response.data.message);
        });
    },  

    searchEleve(e){
      
      if(e.input.length == 3 || e.input.length == 6 || e.input.length == 9 || e.input.length == 12 || e.input.length == 15 || e.input.length == 18 || e.input.length == 21){
          window.api
          .get("/dossier/name/eleves/"+this.$store.state.user.agence.id+"/"+e.input, {
            headers: {
              Authorization: "Bearer " + this.$store.state.token,
            },
          })
          .then((response) => {
            this.elevesName = response.data.utilisateurs;
          })
          .catch((error) => {
            console.log(error);
          });
      }
    },

    selectEleve() {
      window.api
        .get("/dossier/eleve/"+this.eleveSelected.id, {
          headers: {
            Authorization: "Bearer " + this.$store.state.token,
          },
        })
        .then((response) => {
          // Déséléctionne la pièce
          //this.unselectPiece();
          // Séléctionne l'élève
          this.eleveSelected = response.data.utilisateur[0];
          // Si l'élève est séléctionné
          if (this.eleveSelected !== null) {
            // Si la date de naissance doit être reformaté
            if (this.eleveSelected.dossier.dateNaissance.date != undefined) {
              // Reformatage de la date
              this.eleveSelected.dossier.dateNaissance =
                this.eleveSelected.dossier.dateNaissance.date;
            }
          }
        })
        .catch((error) => {
          console.log(error);
        });


    },

    getElevesDossier(offset, mode, filtre){
      window.api
        .get("/dossier/eleves/"+this.$store.state.user.agence.id+"/"+offset + "/" + mode + "/" + filtre, {
          headers: {
            Authorization: "Bearer " + this.$store.state.token,
          },
        })
        .then((response) => {
          this.$store.commit("setElevesDossier", response.data);
        })
        .catch((error) => {
          console.log(error);
        });
    },

    getCountEleves(status){
      window.api
        .get("/dossier/count/eleves/" + this.$store.state.user.agence.id + "/" + status, {
          headers: {
            Authorization: "Bearer " + this.$store.state.token,
          },
        })
        .then((response) => {
          this.countEleves = response.data.utilisateurs;
        })
        .catch((error) => {
          console.log(error);
        });
    },


  },

  computed: {
    elevesDossierLoad() {
      return this.$store.state.elevesDossier !== undefined;
    },
    elevesDossier() {
      // Si la liste des élèves est chargé
      if (this.elevesDossierLoad) {
        // Si la séléction d'agence est "Toutes"
        if (this.agenceSelected === "all") {
          // Retourne toute la liste
          return this.$store.state.elevesDossier.utilisateurs;
        } else if (this.agenceSelected === "null") {
          // Sinon, si la séléction d'agence est "Toutes"
          // Retourne seulement les utilisateurs non rattachés
          return this.$store.state.elevesDossier.utilisateurs.filter(
            (el) => el.agence === null
          );
        } else {
          // Sinon
          // Retourne les utilisateurs rattachés à l'agence séléctionnée
          return this.$store.state.elevesDossier.utilisateurs.filter(
            (el) => el.agence === this.agenceSelected
          );
        }
      }
      return [];
    },

    agences() {
      if (this.elevesDossierLoad) {
        return this.$store.state.elevesDossier.agences;
      }
      return [];
    },

  }

};
</script>
<style scoped>
div.dossier-agence {
  background-color: #f4f6f9;
  min-height: 100vh;
  padding-bottom: 1rem;
}

div.dossier-content {
  width: 70%;
  margin: auto;
  margin-top: 4rem;
  text-align: left;
}

div.dossier-content div.greeting p {
  margin: 0;
  font-size: 14px;
  color: #64748b;
}

div.dossier-content div.greeting h1 {
  font-weight: bold;
}

div.header-dossier {
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 16px;
  transition: box-shadow 0.2s;
  display: flex;
  justify-content: space-between;
  padding: 30px;
  margin-top: 2rem;
  margin-bottom: 1rem;
}

div.header-dossier select {
  width: 30%;
  background-color: #f4f6f9;
  border: 1px solid #e3e9f1;
  border-radius: 15px;
  padding: 15px;
}

div.header-dossier div.search-student {
  display: flex;
  justify-content: flex-start;
  gap: 10px;
  width: 50%;
}

div.header-dossier div.search-student button {
  background-color: #f43f5e;
  border: none;
  color: white;
  padding-top: 5px;
  padding-bottom: 5px;
  padding-left: 15px;
  padding-right: 15px;
  border-radius: 5px;
}

:deep(#typeahead_id_wrapper) {
  width: 80%;
}

:deep(#typeahead_id) {
  border: 1px solid #e2e8f0;
  border-radius: 16px;
  padding: 10px;
  width: 100%;
}

.simple-typeahead :deep(.simple-typeahead-list) {
  position: absolute;
  z-index: 9999;

  background-color: #fff;
  border: 1px solid #ddd;
  border-radius: 4px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  max-height: 300px;
  overflow-y: auto;
  margin: 0;
  padding: 0;
  list-style: none;
  width: 40%;
}

.simple-typeahead :deep(.simple-typeahead-list-item) {
  padding: 8px 12px;
  cursor: pointer;
  font-size: 14px;
}

.simple-typeahead :deep(.simple-typeahead-list-item:hover),
.simple-typeahead
  :deep(.simple-typeahead-list-item.simple-typeahead-list-item-active) {
  background-color: #f0f4ff;
}

/* DATATABLE STYLE */

/* Table wrapper */
:deep(.p-datatable) {
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  overflow: hidden;
  font-size: 14px;
}

/* Header */
:deep(.p-datatable .p-datatable-thead > tr > th) {
  background: #ffffff;
  color: #9ca3af;
  font-weight: 500;
  font-size: 11px;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  padding: 14px 20px;
  border-bottom: 1px solid #f3f4f6;
  border-right: none;
}

/* Rows */
:deep(.p-datatable .p-datatable-tbody > tr) {
  background: #ffffff;
  transition: background 0.15s;
}

:deep(.p-datatable .p-datatable-tbody > tr:hover) {
  background: #f9fafb;
}

:deep(.p-datatable .p-datatable-tbody > tr > td) {
  padding: 18px 20px;
  border-bottom: 1px solid #f3f4f6;
  border-right: none;
  color: #111827;
  font-size: 14px;
}

/* Nom en gras */
:deep(.p-datatable .p-datatable-tbody > tr > td:nth-child(2)) {
  font-weight: 600;
}

/* Suppression du style de sélection par défaut */
:deep(.p-datatable .p-datatable-tbody > tr.p-highlight) {
  background: #f0f9ff;
}


/* Paginator */
:deep(.p-paginator) {
  background: #ffffff;
  border: 1px solid #e5e7eb;
  border-top: none;
  border-radius: 0 0 12px 12px;
  padding: 10px 16px;
}

:deep(.p-paginator .p-paginator-page.p-highlight) {
  background: #3b82f6;
  color: #ffffff;
  border-radius: 8px;
  border-color: #3b82f6;
}

:deep(.p-paginator .p-paginator-page),
:deep(.p-paginator .p-paginator-prev),
:deep(.p-paginator .p-paginator-next),
:deep(.p-paginator .p-paginator-first),
:deep(.p-paginator .p-paginator-last) {
  color: #6b7280;
  border: none;
  min-width: 32px;
  height: 32px;
  border-radius: 8px;
}

:deep(.p-paginator .p-paginator-page:hover:not(.p-highlight)),
:deep(.p-paginator .p-paginator-prev:hover),
:deep(.p-paginator .p-paginator-next:hover) {
  background: #f3f4f6;
}
</style>